<template >

  <v-row v-if="!$apollo.loading">
    <v-col cols="2" offset-md="1">
      <h1>Crear Reglamento</h1>
      <v-text-field label="Título" v-model="info.title"></v-text-field>
    </v-col>
    <v-col cols="8">
      <news-new v-model:value="example_value" ref="new_data"></news-new>
      <v-btn @click="guardar" color="primary">Guardar</v-btn>
    </v-col>
  </v-row>
</template>

<script>
import axios from 'axios';
import NewsNew from "@/components/news/NewsNew.vue";
import gql from "graphql-tag";
export default {
  props:["id"],
  apollo: {
    info: {query: gql` query($id:String!){
       info(id:$id){
        id
        title
        content:contentHtml
      }
    }`,
      variables() {return {"id" :this.id}}
    },
  },
  name:"CreateArticle",
  data() {
    return {
      file: null,
      example_value: '<p>Content of the editor.</p>',
      info: {
        content: '<p>Content of the editor.</p>',
        title: '',
      }
    }
  },
	components: {
    NewsNew,
  },
  methods: {
    guardar(){
      const data = {
        content : this.$refs.new_data.$data.editorData,
        id : this.id,
        title : this.info.title,
      }
      const formData = new FormData();
      formData.append(`file`, this.file );
      formData.append('data', JSON.stringify(data));
      const config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      };
      axios.post('/create_model_rule/',formData,config)
      .then(() => {
        window.location.href = "/"
      })
      .catch(error => {
        console.error(error)
      })
    },
    onChange() {
      console.log("this.content",this.content)
    },
    uploadCallback(url) {
      console.log('uploaded url', url)
    },
    onFileChange(event){
      this.file = event.target.files[0];
    },
  },
  watch:{
    '$apollo.loading'(val){
      console.log(val)
      if(!val){
        this.info = JSON.parse(JSON.stringify(this.info))
        this.example_value = this.info.content
      }
    },
  }
}
</script>
<style>

</style>
